import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { SubSink } from "subsink";
import { EventBusService } from "../../core/services/event-bus.service";
import { NbcLoggerService } from "../../shared/logger/nbc-logger.service";
import { TimesheetService } from "../../shared/services/timesheet.service";
import { SharedDataService } from "../../shared/sharedData.service";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NbcModalConfirmation } from "../../shared/component/confirmation/nbc-modal-confirmation.component";
import { forkJoin, Observable } from "rxjs";
import { AuthorizationService } from "../../shared/services/authorization.service";

@Component({
    selector: "onboarding-tab",
    templateUrl: "./onboarding-component.html",
    standalone: false,
})
export class OnboardingComponent implements OnInit, OnDestroy {
    constructor(
        private _eventBus: EventBusService,
        private _sharedDataService: SharedDataService,
        public _modalService: BsModalService,
        private authorizationService: AuthorizationService,
        private log: NbcLoggerService
    ) {}

    selectedBusinessUnit: any;
    private subs = new SubSink();
    buAccess: any;
    shouldRefreshContents: any = false;

    onBusinessUnitSelected(data: any) {
        this.selectedBusinessUnit = data;

        if (!this.shouldRefreshContents) {
            this.shouldRefreshContents = true;

            setTimeout(() => {
                this.shouldRefreshContents = false;
            }, 1000);
        }
    }

    subscribeEventHandlers() {
        this.subs.sink = this._sharedDataService
            .getSelectedBusinessUnit()
            .subscribe((selectedBu) => this.onBusinessUnitSelected(selectedBu));

        this.subs.sink = this._sharedDataService
            .getBuAccess()
            .subscribe((access) => (this.buAccess = access));
    }

    ngOnInit() {
        this.subscribeEventHandlers();
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
